import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";
import sections from "fantastic/lib/sections";
import { clearHtml } from "fantastic/lib/sanitizer";

export default id => (dispatch, getState) => {
  const node = sections.byId(id, getState().sections);
  if(!node || !node.meta.editable) return;

  const {app: { html: { value } } } = getState();
  const contents = clearHtml(value);

  dispatch({ type: "SECTIONS/UPDATE", payload: { id, data: { contents } } });
  dispatch({ type: "SECTIONS/NODE/EDIT", payload: { id, edit: false } });
  dispatch({ type: "APP/HTML/CLOSE" });

  debouncedSaveTemplate(dispatch, getState);
};
